import type { ComponentProps } from "react";

import { cn } from "../../lib/cn";

/**
 * A placeholder for content that is still loading: a hairline-colored block with a soft light sweeping across it. Give
 * it a height, a width and, for anything but a text line, a radius. It is hidden from assistive technology; announce the
 * loading once, around the skeletons.
 */
export function Skeleton({ className, ...props }: ComponentProps<"div">) {
	return (
		<div
			aria-hidden="true"
			className={cn(
				"animate-shimmer rounded-ctl bg-line bg-linear-to-r from-transparent via-white/60 to-transparent bg-size-[200%_100%] bg-no-repeat motion-reduce:animate-none dark:via-white/5",
				className,
			)}
			{...props}
		/>
	);
}
